/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mission Impact Auth API
 * OpenAPI spec version: v1
 */
export type AcceptAgreementRequestDocumentType =
  (typeof AcceptAgreementRequestDocumentType)[keyof typeof AcceptAgreementRequestDocumentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AcceptAgreementRequestDocumentType = {
  'privacy-policy': 'privacy-policy',
  'terms-of-use': 'terms-of-use',
} as const;

export interface AcceptAgreementRequest {
  documentType: AcceptAgreementRequestDocumentType;
  /** @minLength 1 */
  version: string;
}

export type AccessCheckRequestRequiredRolesItem =
  (typeof AccessCheckRequestRequiredRolesItem)[keyof typeof AccessCheckRequestRequiredRolesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccessCheckRequestRequiredRolesItem = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export interface AccessCheckRequest {
  /** @minLength 1 */
  orgId: string;
  requiredRoles: AccessCheckRequestRequiredRolesItem[];
}

export interface AcknowledgeNoticeRequest {
  /** @minLength 1 */
  orgId: string;
}

export interface ActiveNoticeResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  language: string;
  /** @minLength 1 */
  severity: string;
  /** @minLength 1 */
  acknowledgementMode: string;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  summary: string;
  /** @minLength 1 */
  bodyHtml: string;
  /** @minLength 1 */
  startsAt: string;
  /** @nullable */
  endsAt?: string | null;
  acknowledged: boolean;
  /** @nullable */
  acknowledgedAt?: string | null;
}

/**
 * @nullable
 */
export type AdminEntitlementResponseSource =
  | (typeof AdminEntitlementResponseSource)[keyof typeof AdminEntitlementResponseSource]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEntitlementResponseSource = {
  NUMBER_0: 0,
} as const;

export interface AdminEntitlementResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productRegistrationId: string;
  /** @minLength 1 */
  orgId: string;
  rule: EntitlementRule;
  /**
   * @minLength 1
   * @nullable
   */
  startUtc: string | null;
  /**
   * @minLength 1
   * @nullable
   */
  endUtc: string | null;
  enabled: boolean;
  /** @nullable */
  source?: AdminEntitlementResponseSource;
}

export interface AdminEntitlementsPageResponse {
  items: AdminEntitlementSyncResponse[];
  continuationToken?: string;
  hasMore: boolean;
}

/**
 * @nullable
 */
export type AdminEntitlementSyncResponseSource =
  | (typeof AdminEntitlementSyncResponseSource)[keyof typeof AdminEntitlementSyncResponseSource]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEntitlementSyncResponseSource = {
  NUMBER_0: 0,
} as const;

export interface AdminEntitlementSyncResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productRegistrationId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  ownerType: string;
  /** @nullable */
  organizationId?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  trialId?: string | null;
  /** @nullable */
  stripeSubscriptionId?: string | null;
  /** @nullable */
  stripeSubscriptionLineItemId?: string | null;
  rule: EntitlementRule;
  /** @nullable */
  startUtc?: string | null;
  /** @nullable */
  endUtc?: string | null;
  enabled: boolean;
  isDefault: boolean;
  /** @nullable */
  source?: AdminEntitlementSyncResponseSource;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
}

export type AdminInvitationResponseRole =
  (typeof AdminInvitationResponseRole)[keyof typeof AdminInvitationResponseRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminInvitationResponseRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export type AdminInvitationResponseInvitationState =
  (typeof AdminInvitationResponseInvitationState)[keyof typeof AdminInvitationResponseInvitationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminInvitationResponseInvitationState = {
  Accepted: 'Accepted',
  Invited: 'Invited',
  Declined: 'Declined',
} as const;

export interface AdminInvitationResponse {
  /** @minLength 1 */
  id: string;
  /** @nullable */
  userId?: string | null;
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  organizationId: string;
  role: AdminInvitationResponseRole;
  invitationState: AdminInvitationResponseInvitationState;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
}

export interface AdminOrganizationCurrentPartnerHistoryPageResponse {
  items: AdminOrganizationCurrentPartnerHistoryResponse[];
  continuationToken?: string;
  hasMore: boolean;
}

export interface AdminOrganizationCurrentPartnerHistoryResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  organizationId: string;
  /** @nullable */
  oldPartnerId?: string | null;
  /** @nullable */
  newPartnerId?: string | null;
  /** @minLength 1 */
  changedAtUtc: string;
  /** @minLength 1 */
  actorType: string;
  /** @nullable */
  actorUserId?: string | null;
  actorPrincipal?: string;
  reason?: string;
}

export interface AdminOrganizationResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
  billingCountry?: string;
  isPartner: boolean;
  isNonProfit: boolean;
  partnerIdentifier?: string;
  /** @nullable */
  sourcePartnerId?: string | null;
  /** @nullable */
  currentPartnerId?: string | null;
  features: OrganizationFeatureResponse[];
  consultantHoursAssigned: number;
  consultantHoursSpent: number;
  consultantHoursAvailable: number;
}

export interface AdminOrganizationsPageResponse {
  items: AdminOrganizationResponse[];
  continuationToken?: string;
  hasMore: boolean;
}

export interface AdminProductRegistrationHistoryPageResponse {
  items: AdminProductRegistrationHistoryResponse[];
  continuationToken?: string;
  hasMore: boolean;
}

export interface AdminProductRegistrationHistoryResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productRegistrationId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  ownerType: string;
  /** @nullable */
  organizationId?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  registeredByUserId?: string | null;
  /** @minLength 1 */
  registeredAtUtc: string;
}

export interface AdminProductRegistrationResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  ownerType: string;
  /** @nullable */
  organizationId?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  registeredByUserId?: string | null;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  lastSignedInUtc: string;
}

export interface AdminProductRegistrationsPageResponse {
  items: AdminProductRegistrationResponse[];
  continuationToken?: string;
  hasMore: boolean;
}

export type AdminUserResponseStatus =
  (typeof AdminUserResponseStatus)[keyof typeof AdminUserResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminUserResponseStatus = {
  NUMBER_0: 0,
  NUMBER_1: 1,
} as const;

/**
 * @nullable
 */
export type AdminUserResponsePreferredLanguage =
  | (typeof AdminUserResponsePreferredLanguage)[keyof typeof AdminUserResponsePreferredLanguage]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminUserResponsePreferredLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface AdminUserResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  email: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  status: AdminUserResponseStatus;
  oid?: string;
  tenantId?: string;
  orgName?: string;
  /** @nullable */
  preferredLanguage?: AdminUserResponsePreferredLanguage;
  billingCountry?: string;
  onboarded: boolean;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
}

export type AdminUserRoleResponseRole =
  (typeof AdminUserRoleResponseRole)[keyof typeof AdminUserRoleResponseRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminUserRoleResponseRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export type AdminUserRoleResponseInvitationState =
  (typeof AdminUserRoleResponseInvitationState)[keyof typeof AdminUserRoleResponseInvitationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminUserRoleResponseInvitationState = {
  Accepted: 'Accepted',
  Invited: 'Invited',
  Declined: 'Declined',
} as const;

export interface AdminUserRoleResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  organizationId: string;
  /** @nullable */
  userId?: string | null;
  email?: string;
  role: AdminUserRoleResponseRole;
  invitationState: AdminUserRoleResponseInvitationState;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
}

export interface AdminUserRolesPageResponse {
  items: AdminUserRoleResponse[];
  continuationToken?: string;
  hasMore: boolean;
}

export interface AdminUsersPageResponse {
  items: AdminUserResponse[];
  continuationToken?: string;
  hasMore: boolean;
}

export type AuditEventItemPayload = { [key: string]: unknown };

export interface AuditEventItem {
  /** @minLength 1 */
  id: string;
  /** @nullable */
  actorUserId?: string | null;
  /** @minLength 1 */
  action: string;
  /** @nullable */
  subjectId?: string | null;
  payload?: AuditEventItemPayload;
  timestampUtc?: string;
}

export interface AuditEventsResponse {
  items: AuditEventItem[];
  continuationToken?: string;
  hasMore?: boolean;
}

export interface AvailableAddOn {
  /** @minLength 1 */
  priceId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  productName: string;
  description?: string;
  unitAmount: number;
  /** @minLength 1 */
  currency: string;
  /** @minLength 1 */
  interval: string;
  alreadySubscribed: boolean;
  adjustableQuantity: boolean;
  minQuantity: number;
  /** @nullable */
  maxQuantity?: number | null;
}

export interface AvailableAddOnsResponse {
  addOns: AvailableAddOn[];
}

export interface BillingAddressResponse {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
}

export interface BroadcastDryRunResponse {
  totalRecipients?: number;
  users?: BroadcastUserPreview[];
  orgs?: BroadcastOrgPreview[];
}

export type BroadcastFilterDetailResponseFilterType =
  (typeof BroadcastFilterDetailResponseFilterType)[keyof typeof BroadcastFilterDetailResponseFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BroadcastFilterDetailResponseFilterType = {
  All: 'All',
  Ids: 'Ids',
  ProductRegistration: 'ProductRegistration',
  PaidSubscription: 'PaidSubscription',
  BillingCountry: 'BillingCountry',
} as const;

export interface BroadcastFilterDetailResponse {
  id?: string;
  broadcastId?: string;
  filterType?: BroadcastFilterDetailResponseFilterType;
  ids?: string[];
  productIds?: string[];
  countryCodes?: string[];
}

export interface BroadcastFilterResponse {
  filter?: NotificationBroadcastFilter;
}

export interface BroadcastListResponse {
  broadcasts?: BroadcastResponse[];
  totalCount?: number;
}

export interface BroadcastNotificationItem {
  id?: string;
  type?: string;
  targetId?: string;
  status?: string;
  errorMessage?: string;
  createdUtc?: string;
  updatedUtc?: string;
  attempts?: number;
}

export interface BroadcastNotificationsResponse {
  notifications?: BroadcastNotificationItem[];
  totalCount?: number;
  succeededCount?: number;
  failedCount?: number;
  queuedCount?: number;
}

export interface BroadcastOrgPreview {
  orgId?: string;
  name?: string;
}

export type BroadcastResponseStatus =
  (typeof BroadcastResponseStatus)[keyof typeof BroadcastResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BroadcastResponseStatus = {
  Draft: 'Draft',
  Queued: 'Queued',
  InProgress: 'InProgress',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export type BroadcastResponseRecipientType =
  (typeof BroadcastResponseRecipientType)[keyof typeof BroadcastResponseRecipientType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BroadcastResponseRecipientType = {
  Users: 'Users',
  Orgs: 'Orgs',
  Both: 'Both',
} as const;

export interface BroadcastResponse {
  id?: string;
  name?: string;
  templateId?: string;
  templateEventName?: string;
  status?: BroadcastResponseStatus;
  recipientType?: BroadcastResponseRecipientType;
  createdUtc?: string;
  updatedUtc?: string;
  /** @nullable */
  triggeredUtc?: string | null;
  /** @nullable */
  completedUtc?: string | null;
  /** @nullable */
  totalRecipients?: number | null;
  /** @nullable */
  successCount?: number | null;
  /** @nullable */
  failureCount?: number | null;
  filters?: BroadcastFilterResponse[];
}

export interface BroadcastTriggerResponse {
  broadcastId?: string;
  instanceId?: string;
  message?: string;
}

export interface BroadcastUserPreview {
  userId?: string;
  email?: string;
}

export interface CheckoutResponse {
  /** @minLength 1 */
  checkoutUrl: string;
}

export interface ConsultantHourPackageOffer {
  /** @minLength 1 */
  packageId: string;
  /** @minLength 1 */
  displayName: string;
  hours: number;
  /** @nullable */
  unitAmount?: number | null;
  currency?: string;
}

export interface ConsultantHourPackageOffersResponse {
  packages: ConsultantHourPackageOffer[];
}

export interface ConsultantHourPackageResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  stripePriceId: string;
  /** @minLength 1 */
  displayName: string;
  hours: number;
  active: boolean;
  sortOrder: number;
  /** @nullable */
  unitAmount?: number | null;
  currency?: string;
  stripePriceActive: boolean;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
}

export interface ConsultantHourPackagesListResponse {
  packages: ConsultantHourPackageResponse[];
}

export type ConsultantHoursTransactionResponseType =
  (typeof ConsultantHoursTransactionResponseType)[keyof typeof ConsultantHoursTransactionResponseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConsultantHoursTransactionResponseType = {
  Credit: 'Credit',
  Debit: 'Debit',
} as const;

export interface ConsultantHoursTransactionResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  organizationId: string;
  type: ConsultantHoursTransactionResponseType;
  hours: number;
  availableHoursAfter: number;
  description?: string;
  /** @nullable */
  consultantHourPackageId?: string | null;
  stripeCheckoutSessionId?: string;
  /** @minLength 1 */
  createdByPrincipal: string;
  createdByEmail?: string;
  /** @minLength 1 */
  createdUtc: string;
}

export interface ConsultantHoursTransactionsListResponse {
  items: ConsultantHoursTransactionResponse[];
  totalCount: number;
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export type CreateBroadcastFilterRequestFilterType =
  (typeof CreateBroadcastFilterRequestFilterType)[keyof typeof CreateBroadcastFilterRequestFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBroadcastFilterRequestFilterType = {
  All: 'All',
  Ids: 'Ids',
  ProductRegistration: 'ProductRegistration',
  PaidSubscription: 'PaidSubscription',
  BillingCountry: 'BillingCountry',
} as const;

export interface CreateBroadcastFilterRequest {
  filterType: CreateBroadcastFilterRequestFilterType;
  ids?: string[];
  productIds?: string[];
  countryCodes?: string[];
}

export type CreateBroadcastRequestRecipientType =
  (typeof CreateBroadcastRequestRecipientType)[keyof typeof CreateBroadcastRequestRecipientType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBroadcastRequestRecipientType = {
  Users: 'Users',
  Orgs: 'Orgs',
  Both: 'Both',
} as const;

export interface CreateBroadcastRequest {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  templateId: string;
  recipientType?: CreateBroadcastRequestRecipientType;
}

export interface CreateCheckoutRequest {
  /** @minLength 1 */
  productId: string;
  quantity: number;
  /** @minLength 1 */
  successUrl: string;
  /** @minLength 1 */
  cancelUrl: string;
  locale?: string;
  planId?: string;
}

export interface CreateConsultantHourPackageRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  stripePriceId: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  displayName: string;
  /**
   * @minimum 0.01
   * @maximum 99999999.99
   */
  hours: number;
  sortOrder?: number;
}

export interface CreateConsultantHoursCheckoutRequest {
  /** @minLength 1 */
  packageId: string;
  /** @minLength 1 */
  successUrl: string;
  /** @minLength 1 */
  cancelUrl: string;
  locale?: string;
}

export type CreateConsultantHoursTransactionRequestType =
  (typeof CreateConsultantHoursTransactionRequestType)[keyof typeof CreateConsultantHoursTransactionRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateConsultantHoursTransactionRequestType = {
  Credit: 'Credit',
  Debit: 'Debit',
} as const;

export interface CreateConsultantHoursTransactionRequest {
  type: CreateConsultantHoursTransactionRequestType;
  /**
   * @minimum 0.01
   * @maximum 99999999.99
   */
  hours: number;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
}

export interface CreateDefaultEntitlementRequest {
  rule: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
}

export interface CreateFeatureTagRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  productId: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  featureCode: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description: string;
}

export type CreateInvitationAdminRequestRole =
  (typeof CreateInvitationAdminRequestRole)[keyof typeof CreateInvitationAdminRequestRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateInvitationAdminRequestRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export interface CreateInvitationAdminRequest {
  /** @minLength 1 */
  email: string;
  role: CreateInvitationAdminRequestRole;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
}

export type CreateInvitationRequestRole =
  (typeof CreateInvitationRequestRole)[keyof typeof CreateInvitationRequestRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateInvitationRequestRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export interface CreateInvitationRequest {
  email?: string;
  role?: CreateInvitationRequestRole;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
}

export interface CreateLegalDocumentVersionRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  version: string;
  /** @minItems 1 */
  links: LegalDocumentLinkItem[];
}

export type CreateNotificationTemplateRequestDefaultMode =
  (typeof CreateNotificationTemplateRequestDefaultMode)[keyof typeof CreateNotificationTemplateRequestDefaultMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateNotificationTemplateRequestDefaultMode = {
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Critical: 'Critical',
} as const;

export interface CreateNotificationTemplateRequest {
  /** @minLength 1 */
  eventName: string;
  isActive: boolean;
  defaultMode?: CreateNotificationTemplateRequestDefaultMode;
}

export interface CreateOrganizationAdminRequest {
  /** @minLength 1 */
  name: string;
  billingCountry?: string;
  isPartner?: boolean;
  isNonProfit?: boolean;
  partnerIdentifier?: string;
  /** @nullable */
  sourcePartnerId?: string | null;
}

export interface CreateOrganizationRequest {
  /** @minLength 1 */
  name: string;
  billingCountry?: string;
  /** @nullable */
  sourcePartnerId?: string | null;
}

export interface CreatePortalRequest {
  /** @minLength 1 */
  returnUrl: string;
  locale?: string;
}

export interface CreateProductRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  productId: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  displayName: string;
}

export interface CreateProductTrialRequest {
  rule: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
}

export type CreateRoleRequestRole =
  (typeof CreateRoleRequestRole)[keyof typeof CreateRoleRequestRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateRoleRequestRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export interface CreateRoleRequest {
  /** @nullable */
  userId?: string | null;
  email?: string;
  role: CreateRoleRequestRole;
}

export interface CreateRoleResponse {
  /** @minLength 1 */
  roleId: string;
}

/**
 * @nullable
 */
export type CreateStripePriceEntitlementRequestScenario =
  | (typeof CreateStripePriceEntitlementRequestScenario)[keyof typeof CreateStripePriceEntitlementRequestScenario]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateStripePriceEntitlementRequestScenario = {
  StandardMonthly: 'StandardMonthly',
  StandardAnnual: 'StandardAnnual',
  NonProfitAnnual: 'NonProfitAnnual',
  PartnerSourcedAnnual: 'PartnerSourcedAnnual',
  PartnerAddOn: 'PartnerAddOn',
} as const;

export interface CreateStripePriceEntitlementRequest {
  /** @minLength 1 */
  stripePriceId: string;
  /** @minLength 1 */
  stripeProductId: string;
  entitlementRule: EntitlementRule;
  basePriceId?: string;
  /** @nullable */
  scenario?: CreateStripePriceEntitlementRequestScenario;
  isTierDefault?: boolean;
  adjustableQuantity?: boolean;
  minQuantity?: number;
  /** @nullable */
  maxQuantity?: number | null;
}

export interface CreateSystemNoticeRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  productId: string;
  /** @minLength 1 */
  severity: string;
  /** @minLength 1 */
  acknowledgementMode: string;
  /** @minLength 1 */
  startsAt: string;
  /** @nullable */
  endsAt?: string | null;
  /** @minLength 1 */
  status: string;
  /** @minItems 1 */
  contents: SystemNoticeContentRequest[];
}

export interface DefaultEntitlementResponse {
  productId?: string;
  rule?: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
}

export interface DeviceRegistrationRequest {
  /** @minLength 1 */
  deviceId: string;
  /** @minLength 1 */
  deviceName: string;
}

export interface DeviceRegistrationResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  deviceIdHash: string;
  /** @minLength 1 */
  firstSeenUtc: string;
}

/**
 * @nullable
 */
export type EntitlementDetailSubscriptionStatus =
  | (typeof EntitlementDetailSubscriptionStatus)[keyof typeof EntitlementDetailSubscriptionStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EntitlementDetailSubscriptionStatus = {
  active: 'active',
  past_due: 'past_due',
  unpaid: 'unpaid',
  canceled: 'canceled',
  incomplete: 'incomplete',
} as const;

export interface EntitlementDetail {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  ruleType: string;
  value: number;
  capabilities?: string[];
  isTrial: boolean;
  isDefault: boolean;
  isSubscription: boolean;
  /** @nullable */
  subscriptionStatus?: EntitlementDetailSubscriptionStatus;
  /** @nullable */
  subscriptionAutoRenews?: boolean | null;
  /** @nullable */
  startDate?: string | null;
  /** @nullable */
  expirationDate?: string | null;
}

export type EntitlementRule =
  | CumulativeEntitlementRule
  | MinimumEntitlementRule
  | CapabilityEntitlementRule
  | CompositeEntitlementRule;

export interface FeatureTagResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  featureCode: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
}

export interface FeatureTagsListResponse {
  featureTags: FeatureTagResponse[];
}

export interface GetBillingResponse {
  hasBillingAccount: boolean;
  currency?: string;
  address?: BillingAddressResponse;
  defaultPaymentMethod?: PaymentMethodResponse;
}

export interface GetSubscriptionResponse {
  /** @minLength 1 */
  subscriptionId: string;
  /** @minLength 1 */
  status: string;
  items: SubscriptionLineItemResponse[];
  /** @minLength 1 */
  currency: string;
  total: number;
  hasPendingChanges: boolean;
  /** @nullable */
  pendingChangesEffectiveDate?: string | null;
  cancelAtPeriodEnd: boolean;
}

export interface GrantEntitlementAdminRequest {
  rule: EntitlementRule;
  /** @minLength 1 */
  startUtc: string;
  /** @minLength 1 */
  endUtc: string;
}

export interface InvitationResponse {
  id?: string;
  /** @nullable */
  userId?: string | null;
  email?: string;
  organizationId?: string;
  role?: string;
  invitationState?: string;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
}

export type InvoiceItemStatus = (typeof InvoiceItemStatus)[keyof typeof InvoiceItemStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceItemStatus = {
  Draft: 'Draft',
  Open: 'Open',
  Paid: 'Paid',
  Uncollectible: 'Uncollectible',
  Void: 'Void',
} as const;

export interface InvoiceItem {
  /** @minLength 1 */
  invoiceId: string;
  amount: number;
  /** @minLength 1 */
  currency: string;
  status: InvoiceItemStatus;
  /** @minLength 1 */
  createdAt: string;
  /** @nullable */
  paidAt?: string | null;
  hostedInvoiceUrl?: string;
  invoicePdfUrl?: string;
}

export interface InvoicesListResponse {
  items: InvoiceItem[];
  totalCount: number;
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export interface LanguageResponse {
  /** @minLength 1 */
  code: string;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  nativeName: string;
}

export interface LegalDocumentLinkItem {
  /**
   * @minLength 2
   * @maxLength 10
   */
  language: string;
  /** @minLength 1 */
  url: string;
}

export interface LegalDocumentLinkResponse {
  id?: string;
  language?: string;
  url?: string;
}

export interface LegalDocumentsListResponse {
  privacyPolicy?: LegalDocumentSummary;
  termsOfUse?: LegalDocumentSummary;
}

export interface LegalDocumentSummary {
  activeVersion?: string;
  versions?: LegalDocumentVersionResponse[];
}

export interface LegalDocumentVersionListResponse {
  versions?: LegalDocumentVersionResponse[];
}

export interface LegalDocumentVersionResponse {
  id?: string;
  documentType?: string;
  version?: string;
  isActive?: boolean;
  createdUtc?: string;
  links?: LegalDocumentLinkResponse[];
}

export type NotificationBroadcastStatus =
  (typeof NotificationBroadcastStatus)[keyof typeof NotificationBroadcastStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationBroadcastStatus = {
  Draft: 'Draft',
  Queued: 'Queued',
  InProgress: 'InProgress',
  Completed: 'Completed',
  Failed: 'Failed',
} as const;

export type NotificationBroadcastRecipientType =
  (typeof NotificationBroadcastRecipientType)[keyof typeof NotificationBroadcastRecipientType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationBroadcastRecipientType = {
  Users: 'Users',
  Orgs: 'Orgs',
  Both: 'Both',
} as const;

export interface NotificationBroadcast {
  id?: string;
  name?: string;
  templateId?: string;
  status?: NotificationBroadcastStatus;
  recipientType?: NotificationBroadcastRecipientType;
  createdBy?: string;
  createdUtc?: string;
  updatedUtc?: string;
  /** @nullable */
  triggeredBy?: string | null;
  /** @nullable */
  triggeredUtc?: string | null;
  /** @nullable */
  completedUtc?: string | null;
  /** @nullable */
  totalRecipients?: number | null;
  /** @nullable */
  successCount?: number | null;
  /** @nullable */
  failureCount?: number | null;
  orchestrationInstanceId?: string;
  template?: NotificationTemplate;
  filters?: NotificationBroadcastFilter[];
}

export type NotificationBroadcastFilter =
  | AllBroadcastFilter
  | IdsBroadcastFilter
  | ProductRegistrationBroadcastFilter
  | PaidSubscriptionBroadcastFilter
  | BillingCountryBroadcastFilter;

export type NotificationEvent =
  | EmailNotificationEvent
  | UserNotificationEvent
  | OrgNotificationEvent;

export interface NotificationSettingItem {
  eventName?: string;
  isEnabled?: boolean;
}

export interface NotificationSettingsResponse {
  settings?: NotificationSettingItem[];
}

export interface NotificationSettingUpdateItem {
  /** @minLength 1 */
  eventName: string;
  isEnabled: boolean;
}

export type NotificationTemplateDefaultMode =
  (typeof NotificationTemplateDefaultMode)[keyof typeof NotificationTemplateDefaultMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTemplateDefaultMode = {
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Critical: 'Critical',
} as const;

export interface NotificationTemplate {
  id?: string;
  eventName?: string;
  isActive?: boolean;
  defaultMode?: NotificationTemplateDefaultMode;
  createdBy?: string;
  updatedBy?: string;
  createdUtc?: string;
  updatedUtc?: string;
  localizations?: NotificationTemplateLocalization[];
}

export interface NotificationTemplateListResponse {
  templates: NotificationTemplateResponse[];
}

export type NotificationTemplateLocalizationLanguage =
  (typeof NotificationTemplateLocalizationLanguage)[keyof typeof NotificationTemplateLocalizationLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTemplateLocalizationLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface NotificationTemplateLocalization {
  id?: string;
  templateId?: string;
  language?: NotificationTemplateLocalizationLanguage;
  subject?: string;
  htmlBody?: string;
  lastEditedBy?: string;
  lastEditedUtc?: string;
  template?: NotificationTemplate;
}

export type NotificationTemplateLocalizationResponseLanguage =
  (typeof NotificationTemplateLocalizationResponseLanguage)[keyof typeof NotificationTemplateLocalizationResponseLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTemplateLocalizationResponseLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface NotificationTemplateLocalizationResponse {
  /** @minLength 1 */
  id: string;
  language: NotificationTemplateLocalizationResponseLanguage;
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  htmlBody: string;
  /** @minLength 1 */
  lastEditedUtc: string;
}

export type NotificationTemplateResponseDefaultMode =
  (typeof NotificationTemplateResponseDefaultMode)[keyof typeof NotificationTemplateResponseDefaultMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTemplateResponseDefaultMode = {
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Critical: 'Critical',
} as const;

export interface NotificationTemplateResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  eventName: string;
  isActive: boolean;
  defaultMode: NotificationTemplateResponseDefaultMode;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
  localizations: NotificationTemplateLocalizationResponse[];
}

export interface OrganizationFeatureResponse {
  /** @minLength 1 */
  featureCode: string;
  /** @minLength 1 */
  value: string;
}

export interface OrganizationFeaturesResponse {
  features: OrganizationFeatureResponse[];
}

export type OrganizationMembershipRole =
  (typeof OrganizationMembershipRole)[keyof typeof OrganizationMembershipRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationMembershipRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export type OrganizationMembershipInvitationState =
  (typeof OrganizationMembershipInvitationState)[keyof typeof OrganizationMembershipInvitationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationMembershipInvitationState = {
  Accepted: 'Accepted',
  Invited: 'Invited',
  Declined: 'Declined',
} as const;

export interface OrganizationMembership {
  /** @minLength 1 */
  orgId: string;
  /** @minLength 1 */
  orgName: string;
  role: OrganizationMembershipRole;
  invitationState: OrganizationMembershipInvitationState;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
}

export interface OrganizationResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
  billingCountry?: string;
  /** @nullable */
  sourcePartnerId?: string | null;
  /** @nullable */
  currentPartnerId?: string | null;
  consultantHoursAssigned: number;
  consultantHoursSpent: number;
  consultantHoursAvailable: number;
}

export interface PaymentMethodResponse {
  type?: string;
  cardBrand?: string;
  cardLast4?: string;
  /** @nullable */
  cardExpMonth?: number | null;
  /** @nullable */
  cardExpYear?: number | null;
}

export type PendingAgreementDocumentType =
  (typeof PendingAgreementDocumentType)[keyof typeof PendingAgreementDocumentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PendingAgreementDocumentType = {
  'privacy-policy': 'privacy-policy',
  'terms-of-use': 'terms-of-use',
} as const;

export interface PendingAgreement {
  documentType?: PendingAgreementDocumentType;
  version?: string;
}

export interface PendingAgreementsResponse {
  pending?: PendingAgreement[];
}

export interface PortalResponse {
  /** @minLength 1 */
  portalUrl: string;
}

export interface PreviewLineItem {
  /** @minLength 1 */
  priceId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  productName: string;
  totalAmount: number;
  isProration: boolean;
  /** @nullable */
  quantity?: number | null;
}

export interface PreviewSubscriptionChangeRequest {
  items: ProposedLineItem[];
}

export interface PreviewSubscriptionChangeResponse {
  /** @minLength 1 */
  effectiveDate: string;
  immediateCharge: number;
  newRecurringTotal: number;
  /** @minLength 1 */
  currency: string;
  lineItems: PreviewLineItem[];
}

export type ProblemDetailsExtensions = { [key: string]: { [key: string]: unknown } };

export interface ProblemDetails {
  type?: string;
  title?: string;
  /** @nullable */
  status?: number | null;
  detail?: string;
  instance?: string;
  extensions?: ProblemDetailsExtensions;
}

export interface ProductEntitlementsRollup {
  count: number;
  hasActiveTrial: boolean;
  /** @nullable */
  expiresAt?: string | null;
  isPerpetual: boolean;
  entitlements: EntitlementDetail[];
  capabilities: string[];
  jwt?: string;
  isStripeCustomer: boolean;
}

export type ProductPlanScenario = (typeof ProductPlanScenario)[keyof typeof ProductPlanScenario];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductPlanScenario = {
  StandardMonthly: 'StandardMonthly',
  StandardAnnual: 'StandardAnnual',
  NonProfitAnnual: 'NonProfitAnnual',
  PartnerSourcedAnnual: 'PartnerSourcedAnnual',
  PartnerAddOn: 'PartnerAddOn',
} as const;

export interface ProductPlan {
  /** @minLength 1 */
  planId: string;
  scenario: ProductPlanScenario;
  /** @minLength 1 */
  interval: string;
  /** @nullable */
  unitAmount?: number | null;
  currency?: string;
  /** @minLength 1 */
  displayName: string;
  isDefault: boolean;
  adjustableQuantity: boolean;
  minQuantity: number;
  /** @nullable */
  maxQuantity?: number | null;
  /** @nullable */
  annualizedUnitAmount?: number | null;
  /** @nullable */
  savingsVsMonthlyBps?: number | null;
}

export interface ProductPlansResponse {
  /** @minLength 1 */
  productId: string;
  currency?: string;
  plans: ProductPlan[];
}

export interface ProductRegistrationRequest {
  /** @minLength 1 */
  email: string;
}

export interface ProductRegistrationResponse {
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  lastSignedInUtc: string;
  isNewRegistration: boolean;
}

export interface ProductResponse {
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  displayName: string;
  hasDefaultEntitlement: boolean;
  trialsCount: number;
  defaultStripePriceEntitlementId?: string;
  trialReminderDays?: number[];
}

export interface ProductsListResponse {
  products?: ProductResponse[];
}

export interface ProductTrialResponse {
  id?: string;
  productId?: string;
  token?: string;
  rule?: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
  createdUtc?: string;
  /** @nullable */
  redeemedUtc?: string | null;
}

export interface ProductTrialsListResponse {
  trials?: ProductTrialResponse[];
}

export interface ProposedLineItem {
  /** @minLength 1 */
  priceId: string;
  quantity: number;
}

export interface ProvisionUserRequest {
  /** @minLength 1 */
  email: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  firstName: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  lastName: string;
  /** @maxLength 256 */
  orgName?: string;
}

export interface ProvisionUserResponse {
  userId?: string;
  isNewUser?: boolean;
  /** @nullable */
  orgId?: string | null;
}

export interface RedeemTrialRequest {
  token?: string;
}

export type SendTestNotificationRequestEventData = { [key: string]: { [key: string]: unknown } };

export interface SendTestNotificationRequest {
  /** @minLength 1 */
  eventType: string;
  eventData?: SendTestNotificationRequestEventData;
}

export interface StripeCustomerResponse {
  stripeCustomerId?: string;
  /** @nullable */
  organizationId?: string | null;
  /** @nullable */
  userId?: string | null;
  billingCountry?: string;
  postalCode?: string;
  currency?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface StripeCustomersListResponse {
  items: StripeCustomerResponse[];
  totalCount?: number;
  page?: number;
  pageSize?: number;
  hasMore?: boolean;
}

/**
 * @nullable
 */
export type StripePriceEntitlementResponseScenario =
  | (typeof StripePriceEntitlementResponseScenario)[keyof typeof StripePriceEntitlementResponseScenario]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripePriceEntitlementResponseScenario = {
  StandardMonthly: 'StandardMonthly',
  StandardAnnual: 'StandardAnnual',
  NonProfitAnnual: 'NonProfitAnnual',
  PartnerSourcedAnnual: 'PartnerSourcedAnnual',
  PartnerAddOn: 'PartnerAddOn',
} as const;

export interface StripePriceEntitlementResponse {
  /** @minLength 1 */
  stripePriceId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  stripeProductId: string;
  entitlementRule: EntitlementRule;
  createdAt?: string;
  updatedAt?: string;
  basePriceId?: string;
  /** @nullable */
  scenario?: StripePriceEntitlementResponseScenario;
  isTierDefault: boolean;
  adjustableQuantity: boolean;
  minQuantity: number;
  /** @nullable */
  maxQuantity?: number | null;
}

export interface StripePriceEntitlementsListResponse {
  stripePriceEntitlements: StripePriceEntitlementResponse[];
}

export interface StripePriceResponse {
  /** @minLength 1 */
  stripePriceId: string;
  /** @minLength 1 */
  stripeProductId: string;
  active: boolean;
  /** @minLength 1 */
  createdAt: string;
  /** @minLength 1 */
  updatedAt: string;
  hasEntitlementMapping: boolean;
  isOneTime: boolean;
  /** @nullable */
  unitAmount?: number | null;
  currency?: string;
}

export type StripeProductLocalizationResponseLanguage =
  (typeof StripeProductLocalizationResponseLanguage)[keyof typeof StripeProductLocalizationResponseLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StripeProductLocalizationResponseLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface StripeProductLocalizationResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  stripeProductId: string;
  language: StripeProductLocalizationResponseLanguage;
  /** @minLength 1 */
  name: string;
  description?: string;
}

export interface StripeProductResponse {
  /** @minLength 1 */
  stripeProductId: string;
  /** @minLength 1 */
  name: string;
  description?: string;
  active: boolean;
  /** @minLength 1 */
  createdAt: string;
  /** @minLength 1 */
  updatedAt: string;
  prices: StripePriceResponse[];
  localizations: StripeProductLocalizationResponse[];
}

export interface StripeProductsListResponse {
  products: StripeProductResponse[];
}

export interface StripeSubscriptionLineItemResponse {
  stripeSubscriptionItemId?: string;
  stripePriceId?: string;
  stripeProductId?: string;
  quantity?: number;
  currentPeriodStart?: string;
  currentPeriodEnd?: string;
}

export interface StripeSubscriptionResponse {
  stripeSubscriptionId?: string;
  stripeCustomerId?: string;
  status?: string;
  cancelAtPeriodEnd?: boolean;
  /** @nullable */
  gracePeriodEndsAt?: string | null;
  currency?: string;
  amount?: number;
  createdAt?: string;
  updatedAt?: string;
  lineItems?: StripeSubscriptionLineItemResponse[];
}

export interface StripeSubscriptionsListResponse {
  items: StripeSubscriptionResponse[];
  totalCount?: number;
  page?: number;
  pageSize?: number;
  hasMore?: boolean;
}

export type StripeSyncOrchestrationStatusOutput = { [key: string]: unknown };

export interface StripeSyncOrchestrationStatus {
  instanceId?: string;
  runtimeStatus?: string;
  syncType?: string;
  /** @nullable */
  createdTime?: string | null;
  /** @nullable */
  lastUpdatedTime?: string | null;
  output?: StripeSyncOrchestrationStatusOutput;
  statusQueryGetUri?: string;
}

export interface StripeSyncResult {
  created?: number;
  updated?: number;
  skipped?: number;
  failed?: number;
  total?: number;
}

export interface SubscriptionLineItemResponse {
  /** @minLength 1 */
  itemId: string;
  /** @minLength 1 */
  priceId: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  productName: string;
  description?: string;
  quantity: number;
  unitAmount: number;
  amount: number;
  isAddOn: boolean;
  canRemove: boolean;
  /** @nullable */
  scheduledQuantity?: number | null;
}

export interface SyncStatusResponse {
  instanceId?: string;
  status?: string;
  createdAt?: string;
  lastUpdatedAt?: string;
  output?: StripeSyncResult;
}

export interface SyncTriggeredResponse {
  instanceId?: string;
  statusQueryUrl?: string;
}

export interface SystemNoticeContentRequest {
  /**
   * @minLength 2
   * @maxLength 10
   */
  language: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  summary: string;
  /** @minLength 1 */
  bodyHtml: string;
}

export interface SystemNoticeContentResponse {
  /** @minLength 1 */
  language: string;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  summary: string;
  /** @minLength 1 */
  bodyHtml: string;
  /** @minLength 1 */
  lastEditedBy: string;
  /** @minLength 1 */
  lastEditedAt: string;
}

export interface SystemNoticeResponse {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  productId: string;
  /** @minLength 1 */
  severity: string;
  /** @minLength 1 */
  status: string;
  /** @minLength 1 */
  acknowledgementMode: string;
  /** @minLength 1 */
  startsAt: string;
  /** @nullable */
  endsAt?: string | null;
  /** @minLength 1 */
  createdBy: string;
  /** @minLength 1 */
  updatedBy: string;
  publishedBy?: string;
  /** @minLength 1 */
  createdAt: string;
  /** @minLength 1 */
  updatedAt: string;
  /** @nullable */
  publishedAt?: string | null;
  contents: SystemNoticeContentResponse[];
}

export interface UpdateBroadcastFilterRequest {
  ids?: string[];
  productIds?: string[];
  countryCodes?: string[];
}

/**
 * @nullable
 */
export type UpdateBroadcastRequestRecipientType =
  | (typeof UpdateBroadcastRequestRecipientType)[keyof typeof UpdateBroadcastRequestRecipientType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateBroadcastRequestRecipientType = {
  Users: 'Users',
  Orgs: 'Orgs',
  Both: 'Both',
} as const;

export interface UpdateBroadcastRequest {
  name?: string;
  /** @nullable */
  templateId?: string | null;
  /** @nullable */
  recipientType?: UpdateBroadcastRequestRecipientType;
}

export interface UpdateConsultantHourPackageRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  displayName?: string;
  /**
   * @minimum 0.01
   * @maximum 99999999.99
   * @nullable
   */
  hours?: number | null;
  /** @nullable */
  active?: boolean | null;
  /** @nullable */
  sortOrder?: number | null;
}

/**
 * @nullable
 */
export type UpdateConsultantHoursTransactionRequestType =
  | (typeof UpdateConsultantHoursTransactionRequestType)[keyof typeof UpdateConsultantHoursTransactionRequestType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateConsultantHoursTransactionRequestType = {
  Credit: 'Credit',
  Debit: 'Debit',
} as const;

export interface UpdateConsultantHoursTransactionRequest {
  /** @nullable */
  type?: UpdateConsultantHoursTransactionRequestType;
  /**
   * @minimum 0.01
   * @maximum 99999999.99
   * @nullable
   */
  hours?: number | null;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
}

export interface UpdateDefaultEntitlementRequest {
  rule: EntitlementRule;
  /** @nullable */
  durationDays?: number | null;
}

export interface UpdateEntitlementAdminRequest {
  rule?: EntitlementRule;
  /** @nullable */
  endUtc?: string | null;
  /** @nullable */
  enabled?: boolean | null;
}

export interface UpdateExternalUserRequest {
  givenName?: string;
  surname?: string;
}

export interface UpdateFeatureTagRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  productId?: string;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  description?: string;
}

export interface UpdateNotificationSettingsRequest {
  settings: NotificationSettingUpdateItem[];
}

/**
 * @nullable
 */
export type UpdateNotificationTemplateRequestDefaultMode =
  | (typeof UpdateNotificationTemplateRequestDefaultMode)[keyof typeof UpdateNotificationTemplateRequestDefaultMode]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateNotificationTemplateRequestDefaultMode = {
  Enabled: 'Enabled',
  Disabled: 'Disabled',
  Critical: 'Critical',
} as const;

export interface UpdateNotificationTemplateRequest {
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  defaultMode?: UpdateNotificationTemplateRequestDefaultMode;
}

export interface UpdateOrganizationAdminRequest {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  isPartner?: boolean | null;
  /** @nullable */
  isNonProfit?: boolean | null;
  /** @nullable */
  partnerIdentifier?: string | null;
}

export interface UpdateOrganizationCurrentPartnerAdminRequest {
  /** @nullable */
  currentPartnerId?: string | null;
  reason?: string;
}

export interface UpdateOrganizationCurrentPartnerRequest {
  /** @nullable */
  currentPartnerId?: string | null;
}

export type UpdateOrganizationFeaturesAdminRequestFeatures = { [key: string]: string };

export interface UpdateOrganizationFeaturesAdminRequest {
  features: UpdateOrganizationFeaturesAdminRequestFeatures;
}

export interface UpdateOrganizationRequest {
  /** @minLength 1 */
  name: string;
  billingCountry?: string;
}

export interface UpdateOrganizationSourcePartnerAdminRequest {
  /** @nullable */
  sourcePartnerId?: string | null;
  reason?: string;
}

export interface UpdateOrganizationSourcePartnerRequest {
  /** @nullable */
  sourcePartnerId?: string | null;
}

export interface UpdateProductRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  displayName?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  defaultStripePriceEntitlementId?: string;
  trialReminderDays?: number[];
}

export type UpdateRoleRequestRole =
  (typeof UpdateRoleRequestRole)[keyof typeof UpdateRoleRequestRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRoleRequestRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

/**
 * @nullable
 */
export type UpdateRoleRequestInvitationState =
  | (typeof UpdateRoleRequestInvitationState)[keyof typeof UpdateRoleRequestInvitationState]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRoleRequestInvitationState = {
  Accepted: 'Accepted',
  Invited: 'Invited',
  Declined: 'Declined',
} as const;

export interface UpdateRoleRequest {
  role: UpdateRoleRequestRole;
  /** @nullable */
  invitationState?: UpdateRoleRequestInvitationState;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
}

/**
 * @nullable
 */
export type UpdateStripePriceEntitlementRequestScenario =
  | (typeof UpdateStripePriceEntitlementRequestScenario)[keyof typeof UpdateStripePriceEntitlementRequestScenario]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateStripePriceEntitlementRequestScenario = {
  StandardMonthly: 'StandardMonthly',
  StandardAnnual: 'StandardAnnual',
  NonProfitAnnual: 'NonProfitAnnual',
  PartnerSourcedAnnual: 'PartnerSourcedAnnual',
  PartnerAddOn: 'PartnerAddOn',
} as const;

export interface UpdateStripePriceEntitlementRequest {
  entitlementRule: EntitlementRule;
  /** @nullable */
  scenario?: UpdateStripePriceEntitlementRequestScenario;
  isTierDefault?: boolean;
  adjustableQuantity?: boolean;
  minQuantity?: number;
  /** @nullable */
  maxQuantity?: number | null;
}

export interface UpdateSystemNoticeRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  productId: string;
  /** @minLength 1 */
  severity: string;
  /** @minLength 1 */
  acknowledgementMode: string;
  /** @minLength 1 */
  startsAt: string;
  /** @nullable */
  endsAt?: string | null;
  /** @minLength 1 */
  status: string;
  /** @minItems 1 */
  contents: SystemNoticeContentRequest[];
}

/**
 * @nullable
 */
export type UpdateUserProfileRequestPreferredLanguage =
  | (typeof UpdateUserProfileRequestPreferredLanguage)[keyof typeof UpdateUserProfileRequestPreferredLanguage]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUserProfileRequestPreferredLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

/**
 * @nullable
 */
export type UpdateUserProfileRequestTheme =
  | (typeof UpdateUserProfileRequestTheme)[keyof typeof UpdateUserProfileRequestTheme]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUserProfileRequestTheme = {
  light: 'light',
  dark: 'dark',
  system: 'system',
} as const;

export interface UpdateUserProfileRequest {
  /** @nullable */
  preferredLanguage?: UpdateUserProfileRequestPreferredLanguage;
  /** @nullable */
  theme?: UpdateUserProfileRequestTheme;
  /** @nullable */
  onboarded?: boolean | null;
  billingCountry?: string;
}

export interface UpsertLegalDocumentLinkRequest {
  /**
   * @minLength 2
   * @maxLength 10
   */
  language: string;
  /** @minLength 1 */
  url: string;
}

export type UpsertNotificationTemplateContentRequestLanguage =
  (typeof UpsertNotificationTemplateContentRequestLanguage)[keyof typeof UpsertNotificationTemplateContentRequestLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertNotificationTemplateContentRequestLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface UpsertNotificationTemplateContentRequest {
  language: UpsertNotificationTemplateContentRequestLanguage;
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  htmlBody: string;
}

export type UpsertStripeProductLocalizationRequestLanguage =
  (typeof UpsertStripeProductLocalizationRequestLanguage)[keyof typeof UpsertStripeProductLocalizationRequestLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpsertStripeProductLocalizationRequestLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

export interface UpsertStripeProductLocalizationRequest {
  language: UpsertStripeProductLocalizationRequestLanguage;
  /** @minLength 1 */
  name: string;
  description?: string;
}

export interface UserAgreementsResponse {
  agreements: UserAgreementStatus[];
}

export type UserAgreementStatusDocumentType =
  (typeof UserAgreementStatusDocumentType)[keyof typeof UserAgreementStatusDocumentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserAgreementStatusDocumentType = {
  'privacy-policy': 'privacy-policy',
  'terms-of-use': 'terms-of-use',
} as const;

export interface UserAgreementStatus {
  documentType: UserAgreementStatusDocumentType;
  acceptedVersion?: string;
  /** @nullable */
  acceptedUtc?: string | null;
  /** @minLength 1 */
  currentVersion: string;
  isUpToDate: boolean;
}

export interface UserOrganizations {
  organizations: OrganizationMembership[];
}

/**
 * @nullable
 */
export type UserProfilePreferredLanguage =
  | (typeof UserProfilePreferredLanguage)[keyof typeof UserProfilePreferredLanguage]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserProfilePreferredLanguage = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  es: 'es',
} as const;

/**
 * @nullable
 */
export type UserProfileTheme = (typeof UserProfileTheme)[keyof typeof UserProfileTheme] | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserProfileTheme = {
  light: 'light',
  dark: 'dark',
  system: 'system',
} as const;

export interface UserProfile {
  /** @minLength 1 */
  id: string;
  /** @minLength 1 */
  oid: string;
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  displayName: string;
  firstName?: string;
  lastName?: string;
  /** @minLength 1 */
  status: string;
  /** @nullable */
  preferredLanguage?: UserProfilePreferredLanguage;
  /** @nullable */
  theme?: UserProfileTheme;
  onboarded: boolean;
  billingCountry?: string;
}

export type UserRoleResponseRole = (typeof UserRoleResponseRole)[keyof typeof UserRoleResponseRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserRoleResponseRole = {
  Administrator: 'Administrator',
  Operator: 'Operator',
  Reader: 'Reader',
  Billing: 'Billing',
} as const;

export type UserRoleResponseInvitationState =
  (typeof UserRoleResponseInvitationState)[keyof typeof UserRoleResponseInvitationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserRoleResponseInvitationState = {
  Accepted: 'Accepted',
  Invited: 'Invited',
  Declined: 'Declined',
} as const;

export interface UserRoleResponse {
  /** @minLength 1 */
  id: string;
  /** @nullable */
  userId?: string | null;
  email?: string;
  /** @minLength 1 */
  orgId: string;
  role: UserRoleResponseRole;
  invitationState: UserRoleResponseInvitationState;
  /** @nullable */
  invitationExpiresUtc?: string | null;
  /** @nullable */
  membershipExpiresUtc?: string | null;
  /** @minLength 1 */
  createdUtc: string;
  /** @minLength 1 */
  updatedUtc: string;
}

export interface UserRolesListResponse {
  roles: UserRoleResponse[];
}

/**
 * @nullable
 */
export type EmailNotificationEventData = { [key: string]: Object } | null;

export type EmailNotificationEventType =
  (typeof EmailNotificationEventType)[keyof typeof EmailNotificationEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailNotificationEventType = {
  email: 'email',
} as const;

export interface EmailNotificationEvent {
  email: string;
  language: PreferredLanguage;
  id?: string;
  eventName: string;
  timestamp?: string;
  /** @nullable */
  productId?: string | null;
  /** @nullable */
  data?: EmailNotificationEventData;
  type: EmailNotificationEventType;
}

export type PreferredLanguage = (typeof PreferredLanguage)[keyof typeof PreferredLanguage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PreferredLanguage = {
  En: 'En',
  Fr: 'Fr',
  De: 'De',
  Es: 'Es',
} as const;

export interface Object {
  [key: string]: unknown;
}

/**
 * @nullable
 */
export type UserNotificationEventData = { [key: string]: Object } | null;

export type UserNotificationEventType =
  (typeof UserNotificationEventType)[keyof typeof UserNotificationEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserNotificationEventType = {
  user: 'user',
} as const;

export interface UserNotificationEvent {
  userId: string;
  id?: string;
  eventName: string;
  timestamp?: string;
  /** @nullable */
  productId?: string | null;
  /** @nullable */
  data?: UserNotificationEventData;
  type: UserNotificationEventType;
}

/**
 * @nullable
 */
export type OrgNotificationEventData = { [key: string]: Object } | null;

export type OrgNotificationEventType =
  (typeof OrgNotificationEventType)[keyof typeof OrgNotificationEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrgNotificationEventType = {
  org: 'org',
} as const;

export interface OrgNotificationEvent {
  orgId: string;
  id?: string;
  eventName: string;
  timestamp?: string;
  /** @nullable */
  productId?: string | null;
  /** @nullable */
  data?: OrgNotificationEventData;
  type: OrgNotificationEventType;
}

export type CumulativeEntitlementRuleType =
  (typeof CumulativeEntitlementRuleType)[keyof typeof CumulativeEntitlementRuleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CumulativeEntitlementRuleType = {
  cumulative: 'cumulative',
} as const;

export interface CumulativeEntitlementRule {
  count: number;
  type: CumulativeEntitlementRuleType;
}

export type MinimumEntitlementRuleType =
  (typeof MinimumEntitlementRuleType)[keyof typeof MinimumEntitlementRuleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MinimumEntitlementRuleType = {
  minimum: 'minimum',
} as const;

export interface MinimumEntitlementRule {
  minimum: number;
  type: MinimumEntitlementRuleType;
}

export type CapabilityEntitlementRuleType =
  (typeof CapabilityEntitlementRuleType)[keyof typeof CapabilityEntitlementRuleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CapabilityEntitlementRuleType = {
  capability: 'capability',
} as const;

export interface CapabilityEntitlementRule {
  capabilities: string[];
  type: CapabilityEntitlementRuleType;
}

export type CompositeEntitlementRuleType =
  (typeof CompositeEntitlementRuleType)[keyof typeof CompositeEntitlementRuleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompositeEntitlementRuleType = {
  composite: 'composite',
} as const;

export interface CompositeEntitlementRule {
  rules: EntitlementRule[];
  type: CompositeEntitlementRuleType;
}

export type AllBroadcastFilterFilterType =
  (typeof AllBroadcastFilterFilterType)[keyof typeof AllBroadcastFilterFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AllBroadcastFilterFilterType = {
  All: 'All',
} as const;

export interface AllBroadcastFilter {
  id: string;
  notificationBroadcastId: string;
  filterType: AllBroadcastFilterFilterType;
}

export type IdsBroadcastFilterFilterType =
  (typeof IdsBroadcastFilterFilterType)[keyof typeof IdsBroadcastFilterFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IdsBroadcastFilterFilterType = {
  Ids: 'Ids',
} as const;

export interface IdsBroadcastFilter {
  ids?: string[];
  id: string;
  notificationBroadcastId: string;
  filterType: IdsBroadcastFilterFilterType;
}

export type ProductRegistrationBroadcastFilterFilterType =
  (typeof ProductRegistrationBroadcastFilterFilterType)[keyof typeof ProductRegistrationBroadcastFilterFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductRegistrationBroadcastFilterFilterType = {
  ProductRegistration: 'ProductRegistration',
} as const;

export interface ProductRegistrationBroadcastFilter {
  productIds?: string[];
  id: string;
  notificationBroadcastId: string;
  filterType: ProductRegistrationBroadcastFilterFilterType;
}

export type PaidSubscriptionBroadcastFilterFilterType =
  (typeof PaidSubscriptionBroadcastFilterFilterType)[keyof typeof PaidSubscriptionBroadcastFilterFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaidSubscriptionBroadcastFilterFilterType = {
  PaidSubscription: 'PaidSubscription',
} as const;

export interface PaidSubscriptionBroadcastFilter {
  /** @nullable */
  productIds?: string[] | null;
  id: string;
  notificationBroadcastId: string;
  filterType: PaidSubscriptionBroadcastFilterFilterType;
}

export type BillingCountryBroadcastFilterFilterType =
  (typeof BillingCountryBroadcastFilterFilterType)[keyof typeof BillingCountryBroadcastFilterFilterType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BillingCountryBroadcastFilterFilterType = {
  BillingCountry: 'BillingCountry',
} as const;

export interface BillingCountryBroadcastFilter {
  countryCodes?: string[];
  id: string;
  notificationBroadcastId: string;
  filterType: BillingCountryBroadcastFilterFilterType;
}

export type GetHealth200 = { [key: string]: 0 | 1 };

export type GetHealth500 = { [key: string]: 0 | 1 };

export type GetActiveSystemNoticesParams = {
  /**
   * The product identifier
   */
  productId: string;
  /**
   * Preferred language (defaults to English)
   */
  language?: string;
  /**
   * Organization identifier
   */
  orgId: string;
  /**
   * Include acknowledged notices (default: true)
   */
  includeAcknowledged?: boolean;
  /**
   * Optional evaluation timestamp (defaults to server time) - useful for testing/preview
   */
  now?: string;
};

export type ConsumerGetSystemNoticeParams = {
  /**
   * Preferred language (defaults to English)
   */
  language?: string;
  /**
   * Organization identifier
   */
  orgId: string;
};

export type GetUserProductEntitlementsParams = {
  /**
   * User ID (required for service-to-service requests with Entitlements.Read role)
   */
  userId?: string;
  /**
   * Include signed JWT with entitlement claims (default: false)
   */
  jwt?: boolean;
};

export type GetOrganizationProductEntitlementsParams = {
  /**
   * Include signed JWT with entitlement claims (default: false)
   */
  jwt?: boolean;
};

export type GetAuditParams = {
  /**
   * Number of items per page (default 50, max 100)
   */
  pageSize?: number;
  /**
   * Continuation token for pagination
   */
  continuationToken?: string;
  /**
   * Filter by actor user ID
   */
  actorUserId?: string;
  /**
   * Filter by action (UserProvisioned, ConsentRecorded)
   */
  action?: string;
  /**
   * Filter by timestamp (ISO 8601 datetime)
   */
  since?: string;
};

export type GetOrgInvoicesParams = {
  /**
   * Page number (1-based, default 1)
   */
  page?: number;
  /**
   * Items per page (default 20, max 100)
   */
  pageSize?: number;
};

export type AdminGetBroadcastsParams = {
  /**
   * Page number (1-based, default: 1)
   */
  page?: number;
  /**
   * Number of items per page (default: 20, max: 100)
   */
  pageSize?: number;
  /**
   * Optional template ID to filter broadcasts
   */
  templateId?: string;
};

export type AdminGetBroadcastNotificationsParams = {
  /**
   * Page number (1-based, default: 1)
   */
  page?: number;
  /**
   * Number of items per page (default: 20, max: 100)
   */
  pageSize?: number;
};

export type AdminGetConsultantHoursTransactionsParams = {
  /**
   * Page number (1-based, default 1)
   */
  page?: number;
  /**
   * Items per page (default 20, max 100)
   */
  pageSize?: number;
};

export type AdminListOrganizationsParams = {
  /**
   * Number of items per page (default 50, max 100)
   */
  pageSize?: number;
  /**
   * Opaque continuation token returned by the previous page
   */
  continuationToken?: string;
  /**
   * Filter by IsPartner flag
   */
  isPartner?: boolean;
  /**
   * Filter by IsNonProfit flag
   */
  isNonProfit?: boolean;
};

export type AdminListOrganizationCurrentPartnerHistoryParams = {
  /**
   * Number of items per page (default 50, max 100)
   */
  pageSize?: number;
  /**
   * Opaque continuation token returned by the previous page
   */
  continuationToken?: string;
  /**
   * Filter to history rows for this customer organization
   */
  organizationId?: string;
};

export type AdminListProductEntitlementsParams = {
  /**
   * Number of items per page (default 50, max 100)
   */
  pageSize?: number;
  /**
   * Opaque continuation token returned by the previous page
   */
  continuationToken?: string;
  /**
   * Filter to entitlements whose Registration is org-scoped with this org id
   */
  organizationId?: string;
  /**
   * Filter to entitlements whose Registration is user-scoped with this user id
   */
  userId?: string;
  /**
   * Filter by parent registration's product id
   */
  productId?: string;
  /**
   * Filter by entitlement source
   */
  source?: AdminListProductEntitlementsSource;
  /**
   * Filter by enabled flag
   */
  enabled?: boolean;
};

export type AdminListProductEntitlementsSource =
  (typeof AdminListProductEntitlementsSource)[keyof typeof AdminListProductEntitlementsSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminListProductEntitlementsSource = {
  NUMBER_0: 0,
} as const;

export type AdminListProductRegistrationsParams = {
  /**
   * Number of items per page (default 50, max 100)
   */
  pageSize?: number;
  /**
   * Opaque continuation token returned by the previous page
   */
  continuationToken?: string;
  /**
   * Filter to OrgProductRegistration rows for this org
   */
  organizationId?: string;
  /**
   * Filter to UserProductRegistration rows for this user
   */
  userId?: string;
  /**
   * Filter by product id
   */
  productId?: string;
};

export type AdminListProductRegistrationHistoryParams = {
  /**
   * Number of items per page (default 50, max 100)
   */
  pageSize?: number;
  /**
   * Opaque continuation token returned by the previous page
   */
  continuationToken?: string;
  /**
   * Filter to OrgProductRegistrationHistory rows for this org
   */
  organizationId?: string;
  /**
   * Filter to UserProductRegistrationHistory rows for this user
   */
  userId?: string;
  /**
   * Filter by product id
   */
  productId?: string;
  /**
   * Filter to a single parent registration's history
   */
  productRegistrationId?: string;
};

export type AdminListSystemNoticesParams = {
  /**
   * Filter by product ID
   */
  productId?: string;
  /**
   * Filter by status (draft, published, scheduled, archived)
   */
  status?: string;
  /**
   * Filter by severity (info, urgent)
   */
  severity?: string;
  /**
   * Include archived notices (default: false)
   */
  includeArchived?: boolean;
};

export type AdminListUserRolesParams = {
  /**
   * Number of items per page (default 50, max 100)
   */
  pageSize?: number;
  /**
   * Opaque continuation token returned by the previous page
   */
  continuationToken?: string;
  /**
   * Filter by organization id
   */
  organizationId?: string;
  /**
   * Filter by invitation state
   */
  invitationState?: AdminListUserRolesInvitationState;
  /**
   * Filter by role
   */
  role?: AdminListUserRolesRole;
};

export type AdminListUserRolesInvitationState =
  (typeof AdminListUserRolesInvitationState)[keyof typeof AdminListUserRolesInvitationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminListUserRolesInvitationState = {
  accepted: 'accepted',
  invited: 'invited',
  declined: 'declined',
} as const;

export type AdminListUserRolesRole =
  (typeof AdminListUserRolesRole)[keyof typeof AdminListUserRolesRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminListUserRolesRole = {
  administrator: 'administrator',
  operator: 'operator',
  reader: 'reader',
  billing: 'billing',
} as const;

export type AdminListUsersParams = {
  /**
   * Number of items per page (default 50, max 100)
   */
  pageSize?: number;
  /**
   * Opaque continuation token returned by the previous page
   */
  continuationToken?: string;
  /**
   * Exact-match email filter
   */
  email?: string;
};

export type AdminGetStripeCustomersParams = {
  /**
   * Page number (1-based, default: 1)
   */
  page?: number;
  /**
   * Number of items per page (default: 20, max: 100)
   */
  pageSize?: number;
};

export type AdminGetStripeProductsParams = {
  /**
   * Whether to include inactive products (default: false)
   */
  includeInactive?: boolean;
};

export type AdminGetStripeSubscriptionsParams = {
  /**
   * Page number (1-based, default: 1)
   */
  page?: number;
  /**
   * Number of items per page (default: 20, max: 100)
   */
  pageSize?: number;
};
